import updateCartQuantity from "./updateCartQuantity";
import removeCartItem from "./removeCartItem";
import PubSub from "../../utils/PubSub";

document.addEventListener("DOMContentLoaded", () => {
  const cartItems = document.querySelector(".cart-items");

  // Only initialize cart functionality if cart items exist
  if (cartItems) {
    setupCartEventSubscriptions();
    cartItems.addEventListener("click", handleCartInteractions);
  }
});

function handleCartInteractions(e) {
  const cartItem = e.target.closest(".cart-item");
  if (!cartItem) return;

  const key = cartItem.dataset.key;

  if (e.target.classList.contains("quantity-btn")) {
    handleQuantityChange(e, cartItem);
  }

  if (e.target.classList.contains("remove-item")) {
    removeCartItem(key);
  }
}

function handleQuantityChange(e, cartItem) {
  const input = cartItem.querySelector("input");
  const currentVal = parseInt(input.value);
  const maxStock = parseInt(input.getAttribute("data-stock"), 10) || 9999;

  let newValue = currentVal;

  if (e.target.classList.contains("minus") && currentVal > 1) {
    newValue = currentVal - 1;
  } else if (e.target.classList.contains("plus") && currentVal < maxStock) {
    newValue = currentVal + 1;
  } else {
    return;
  }

  updateCartQuantity(cartItem.dataset.key, newValue);
}

function setupCartEventSubscriptions() {
  // Handle quantity updates
  PubSub.subscribe("cart:quantityUpdate:success", ({ key, data }) => {
    const cartItem = document.querySelector(
      `.cart-items .cart-item[data-key="${key}"]`
    );

    if (cartItem) {
      updateQuantityUI(cartItem, data.quantity);
      document.querySelector(".cart-totals .subtotal .amount").innerHTML =
        data.totals;
    }
  });

  // Handle item removal
  PubSub.subscribe("cart:itemRemove:success", ({ data }) => {
    const { key, totals, itemCount } = data;
    const cartItem = document.querySelector(
      `.cart-items .cart-item[data-key="${key}"]`
    );

    if (cartItem) {
      cartItem.remove();
      document.querySelector(".cart-totals .subtotal .amount").innerHTML =
        totals;
    }

    if (itemCount === 0) {
      location.reload();
    }
  });
}

function updateQuantityUI(cartItem, newQuantity) {
  const input = cartItem.querySelector("input");
  const minusBtn = cartItem.querySelector(".minus");
  const plusBtn = cartItem.querySelector(".plus");
  const maxStock = parseInt(input?.getAttribute("data-stock"), 10) || 9999;

  if (input) input.value = newQuantity;
  if (minusBtn) minusBtn.disabled = newQuantity <= 1;
  if (plusBtn) plusBtn.disabled = newQuantity >= maxStock;
}
